import { render, staticRenderFns } from "./BMap.vue?vue&type=template&id=5fd0beec"
import script from "./BMap.vue?vue&type=script&lang=js"
export * from "./BMap.vue?vue&type=script&lang=js"
import style0 from "./BMap.vue?vue&type=style&index=0&id=5fd0beec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports